// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d140b194","171":"2eeab739","388":"51bb5854","453":"31935662","952":"fb44cf9d"}[chunkId] + ".chunk.js";
};